var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcSortUp16 = function SvgIcSortUp16(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A394D",
    d: "M11.416 6.653a.659.659 0 0 0 .858-1L8.43 2.359a.659.659 0 0 0-.858 0L3.73 5.653a.659.659 0 0 0 .858 1l3.414-2.926 3.414 2.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M11.416 9.349a.659.659 0 1 1 .858 1L8.43 13.643a.659.659 0 0 1-.858 0L3.73 10.35a.659.659 0 1 1 .858-1l3.414 2.926 3.414-2.926z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcSortUp16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-sort-up-16.f1db55fd2f27c940c2ea7bf99e54d072.svg";